'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002eutil$002e$002dLeft from "./scala.util.-Left.js";
import * as $j_scala$002eutil$002e$002dRight from "./scala.util.-Right.js";
var $p;
/** @constructor */
function $c_Ldev_cheleb_scalamigen_IronTypeValidator$given\uff3fIronTypeValidator\uff3fA\uff3fC(baseValidator, constraint) {
  this.HJ = null;
  this.zp = null;
  this.HJ = baseValidator;
  this.zp = constraint;
}
export { $c_Ldev_cheleb_scalamigen_IronTypeValidator$given\uff3fIronTypeValidator\uff3fA\uff3fC as $c_Ldev_cheleb_scalamigen_IronTypeValidator$given\uff3fIronTypeValidator\uff3fA\uff3fC };
$p = $c_Ldev_cheleb_scalamigen_IronTypeValidator$given\uff3fIronTypeValidator\uff3fA\uff3fC.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ldev_cheleb_scalamigen_IronTypeValidator$given\uff3fIronTypeValidator\uff3fA\uff3fC;
/** @constructor */
function $h_Ldev_cheleb_scalamigen_IronTypeValidator$given\uff3fIronTypeValidator\uff3fA\uff3fC() {
}
export { $h_Ldev_cheleb_scalamigen_IronTypeValidator$given\uff3fIronTypeValidator\uff3fA\uff3fC as $h_Ldev_cheleb_scalamigen_IronTypeValidator$given\uff3fIronTypeValidator\uff3fA\uff3fC };
$h_Ldev_cheleb_scalamigen_IronTypeValidator$given\uff3fIronTypeValidator\uff3fA\uff3fC.prototype = $p;
$p.jx = (function(a) {
  var this$1 = this.HJ.jx(a);
  if ((this$1 instanceof $j_scala$002eutil$002e$002dRight.$c_s_util_Right)) {
    var b = this$1.h9;
    return ((!(!this.zp.zs.j(b))) ? new $j_scala$002eutil$002e$002dRight.$c_s_util_Right(b) : new $j_scala$002eutil$002e$002dLeft.$c_s_util_Left(this.zp.zt));
  } else {
    return this$1;
  }
});
var $d_Ldev_cheleb_scalamigen_IronTypeValidator$given\uff3fIronTypeValidator\uff3fA\uff3fC = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ldev_cheleb_scalamigen_IronTypeValidator$given\uff3fIronTypeValidator\uff3fA\uff3fC, "dev.cheleb.scalamigen.IronTypeValidator$given_IronTypeValidator_A_C", ({
  jd: 1,
  jc: 1
}));
export { $d_Ldev_cheleb_scalamigen_IronTypeValidator$given\uff3fIronTypeValidator\uff3fA\uff3fC as $d_Ldev_cheleb_scalamigen_IronTypeValidator$given\uff3fIronTypeValidator\uff3fA\uff3fC };
